"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricePerInterval = void 0;
class PricePerInterval {
    amount;
    currency;
    interval;
    intervalCount;
    constructor(amount, currency, interval, intervalCount = 1) {
        this.amount = amount;
        this.currency = currency;
        this.interval = interval;
        this.intervalCount = intervalCount;
    }
    format() {
        return `${this.getAmountLabel()}/${this.getIntervalLabel()}`;
    }
    formatReadable(includeAmount = true) {
        const amountPart = includeAmount ? `${this.getAmountLabel()} ` : "";
        return `${amountPart}${this.getReadableIntervalLabel()}`;
    }
    getAmountLabel() {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: this.currency || "USD",
        }).format(this.amount);
    }
    getIntervalLabel() {
        if (this.intervalCount > 1)
            return `${this.intervalCount}-${this.getIntervalAbbreviation()}`;
        return this.getIntervalAbbreviation();
    }
    getIntervalAbbreviation() {
        switch (this.interval) {
            case "month":
                return "mo";
            case "week":
                return "wk";
            case "year":
                return "yr";
            case "day":
                return "dy";
        }
    }
    getReadableIntervalLabel() {
        if (this.intervalCount > 1) {
            return `every ${this.intervalCount} ${this.interval}s`;
        }
        return this.getReadableIntervalName();
    }
    getReadableIntervalName() {
        switch (this.interval) {
            case "month":
                return "monthly";
            case "week":
                return "weekly";
            case "year":
                return "yearly";
            case "day":
                return "daily";
        }
    }
}
exports.PricePerInterval = PricePerInterval;
//# sourceMappingURL=PricePerInterval.js.map